<div class="loading-container" role="status" aria-live="polite">
  <div class="content">
    <img src="assets/cb/images/loading_box.gif" alt="">
    <h1>{{content.toUpperCase()}}...</h1>
    @if (showLoadingBar) {
      <p #bodyText [class.d-none]="!hasProjectedBodyText"><ng-content></ng-content></p>
      @if (!hasProjectedBodyText) {
        <p>{{ defaultBodyText }}</p>
      }
    }
    @if (showLoadingBar) {
      <div class="loading-progress-container">
        <div class="loading-progress" [ngStyle]="{ 'width': loadingProgress + '%' }"></div>
      </div>
    }
  </div>
</div>
